export const ALL_RIGHT = {
  pt: "Tudo certo",
  es: "Muy bien.",
  en: "All set",
};

export const LOGIN_DONE = {
  pt: "Login realizado com sucesso",
  es: "Inicio de sesión con éxito",
  en: "Login successfully done",
};

export const ONLY_ADMIN_CAN = {
  pt: "Apenas administradores podem acessar esse sistema!",
  es: "Sólo los administradores pueden acceder a este sistema.",
  en: "Only administrators can access the system!",
};

export const ADMIN_CHECK_FAILED = {
  pt: "Não foi possível verificar sua permissão de acesso agora. Isso costuma ser temporário: sua sessão foi encerrada, entre novamente em alguns instantes.",
  es: "No fue posible verificar tu permiso de acceso ahora. Suele ser temporal: tu sesión fue cerrada, inicia sesión nuevamente en unos instantes.",
  en: "We could not verify your access permission right now. This is usually temporary: your session was ended, please sign in again in a few moments.",
};

export const WENT_WONG = {
  pt: "Algo deu errado!",
  es: "¡Algo salió mal!",
  en: "Something went wrong!",
};

export const CHECK_AUTH = {
  pt: "Verifique suas credenciais",
  es: "Compruebe sus credenciales",
  en: "Check your credentials",
};

export const EMAIL = {
  pt: "E-mail",
  es: "Correo electrónico",
  en: "E-mail",
};

export const PASSWORD = {
  pt: "Senha",
  es: "Contraseña",
  en: "Password",
};

export const ENTER = {
  pt: "Entrar",
  es: "Entrar en el sistema",
  en: "Login",
};

export const MAKE_LOGIN = {
  pt: "Entrar",
  es: "Acceso",
  en: "Log in",
};

export const FORGOT_PASSWORD = {
  pt: "Esqueceu a senha?",
  es: "¿Olvidó su contraseña?",
  en: "Forgot password?",
};

export const RESET_PASSWORD_TITLE = {
  pt: "Redefinir senha",
  es: "Restablecer contraseña",
  en: "Reset password",
};

export const BACK_TO_LOGIN = {
  pt: "Voltar ao login",
  es: "Volver al inicio de sesión",
  en: "Back to login",
};

export const STEP_EMAIL_TITLE = {
  pt: "E-mail",
  es: "Correo electrónico",
  en: "Email",
};

export const STEP_CODE_TITLE = {
  pt: "Código",
  es: "Código",
  en: "Code",
};

export const STEP_PASSWORD_TITLE = {
  pt: "Nova senha",
  es: "Nueva contraseña",
  en: "New password",
};

export const ENTER_YOUR_EMAIL = {
  pt: "Digite seu e-mail para receber o código de verificação",
  es: "Ingrese su correo electrónico para recibir el código de verificación",
  en: "Enter your email to receive the verification code",
};

export const SEND_CODE = {
  pt: "Enviar código",
  es: "Enviar código",
  en: "Send code",
};

export const ENTER_CODE = {
  pt: "Digite o código de 6 dígitos enviado para",
  es: "Ingrese el código de 6 dígitos enviado a",
  en: "Enter the 6-digit code sent to",
};

export const VERIFY_CODE = {
  pt: "Verificar código",
  es: "Verificar código",
  en: "Verify code",
};

export const RESEND_CODE = {
  pt: "Reenviar código",
  es: "Reenviar código",
  en: "Resend code",
};

export const NEW_PASSWORD = {
  pt: "Nova senha",
  es: "Nueva contraseña",
  en: "New password",
};

export const CONFIRM_PASSWORD = {
  pt: "Confirmar nova senha",
  es: "Confirmar nueva contraseña",
  en: "Confirm new password",
};

export const RESET_PASSWORD_BTN = {
  pt: "Redefinir senha",
  es: "Restablecer contraseña",
  en: "Reset password",
};

export const CODE_SENT_SUCCESS = {
  pt: "Código enviado com sucesso para o seu e-mail",
  es: "Código enviado con éxito a su correo electrónico",
  en: "Code sent successfully to your email",
};

export const CODE_VERIFIED = {
  pt: "Código verificado com sucesso",
  es: "Código verificado con éxito",
  en: "Code verified successfully",
};

export const PASSWORD_RESET_SUCCESS = {
  pt: "Senha redefinida com sucesso! Faça login com sua nova senha.",
  es: "¡Contraseña restablecida con éxito! Inicie sesión con su nueva contraseña.",
  en: "Password reset successfully! Login with your new password.",
};

export const INVALID_CODE = {
  pt: "Código inválido ou expirado. Tente novamente.",
  es: "Código inválido o expirado. Inténtelo de nuevo.",
  en: "Invalid or expired code. Please try again.",
};

export const PASSWORDS_DO_NOT_MATCH = {
  pt: "As senhas não coincidem",
  es: "Las contraseñas no coinciden",
  en: "Passwords do not match",
};

export const PASSWORD_MIN_LENGTH = {
  pt: "A senha deve ter pelo menos 6 caracteres",
  es: "La contraseña debe tener al menos 6 caracteres",
  en: "Password must be at least 6 characters",
};

export const CODE_LABEL = {
  pt: "Código de verificação",
  es: "Código de verificación",
  en: "Verification code",
};

export const DONT_HAVE_ACCOUNT = {
  pt: "Não tem conta?",
  es: "¿No tiene cuenta?",
  en: "Don't have an account?",
};

export const SIGN_UP = {
  pt: "Cadastre-se",
  es: "Regístrese",
  en: "Sign up",
};
